import React from 'react';
import { useUniqueName } from '../../hooks/useUniqueName';
import FieldSet from '../FieldSet/FieldSet';
import { type TimePickerProps } from './TimePicker.types';

const TimePicker = React.forwardRef(
  (props: TimePickerProps, ref: React.ForwardedRef<HTMLInputElement>) => {
    const {
      colorMode,
      className = '',
      dataTestId = 'time-picker',
      error = false,
      onChange = () => null,
      showSecond = false,
      name: givenName = 'solink-time',
      title,
      inline,
      value = '00:00',
      ...rest
    } = props;

    const startOfDay = showSecond ? '00:00:00' : '00:00';

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
      const value = event.target.value;

      /** fallback to startOfDay for invalid times */
      const isEmpty = value === '';
      onChange?.((isEmpty ? startOfDay : value) || undefined);
    };

    const name = useUniqueName(givenName);

    const input = (
      <input
        type="time"
        className={`time-picker-input ${error ? 'error' : ''} ${className || ''}`}
        data-testid={dataTestId}
        onChange={handleChange}
        placeholder={startOfDay}
        title={title || name || 'solink-time-picker'}
        step={showSecond ? 1 : 60}
        name={name}
        ref={ref}
        value={value}
        {...rest}
      />
    );

    if (inline) {
      return input;
    }
    return (
      <FieldSet
        className={`solink-time-picker-wrapper`}
        colorMode={colorMode || 'light'}
        name={name}
        disabled={props.disabled}
        error={error}
      >
        {input}
      </FieldSet>
    );
  },
);

// Display Name
TimePicker.displayName = 'TimePicker';

export default TimePicker;
